module.exports = __webpack_public_path__ + "static/media/coordinadores.589f4d0b.jpg";